import { Component, OnInit, Input, OnChanges, SimpleChanges, Injector } from '@angular/core';
import { TaskOrder } from './taskorders';
import { TaskOrderService } from './taskorders.service';
import { KindBoard } from 'src/utils/enums';
import { TaskItem } from '../../taskcommon/taskcommon.class';
import { PageBase } from 'src/app/shared/library/page.base';

@Component({
    selector: 'cp-taskorders',
    templateUrl: './taskorders.component.html',
    styleUrls: ['./taskorders.component.css'],
    standalone: false
})
export class TaskOrdersComponent extends PageBase implements OnInit, OnChanges  {

  @Input() taskitem: TaskItem;
  isHideLoading = true;
  taskOrder: TaskOrder = new TaskOrder();
  Kind = KindBoard.Tarefa;

  constructor(private taskOrderService: TaskOrderService,
              public ObjInjector: Injector)
  {
    super(ObjInjector);
  }

  ngOnInit(): void {
    super.ngOnInit();
    this.taskOrder.id = this.taskOrder.ordervalue = this.taskOrder.orderdelivered = this.taskOrder.balancevalue = 0;
    this.taskitem = new TaskItem();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.taskitem)
    {
      this.isHideLoading = false;
      this.load();
    }
  }

  async load() {
    if(this.contextApplication.currentVision == KindBoard.Tarefa.valueOf()) {
      this.taskOrder = await this.taskOrderService.GetTaskOrder(this.taskitem);
    }
    else {
      this.taskOrder = await this.taskOrderService.GetTaskOrderByInput(this.taskitem);
    }
    this.isHideLoading = true;
  }

  onReceiveLiterals() { }

}
